import React from 'react';
import PropTypes from 'prop-types';
import { Card, Title, BtnGroup, Option } from '../survey.css';

const SalesMethod = ({ setSalesMethod, nextStep, queryParams }) => (
  <Card>
    <Title>
      How do you want to
      <br />
      sell your home?
    </Title>

    <BtnGroup>
      <Option
        circles={
          queryParams && queryParams.circles && queryParams.circles === 'true'
        }
        onClick={() => setSalesMethod('Traditional', nextStep)}
      >
        Traditional
      </Option>
      <Option
        circles={
          queryParams && queryParams.circles && queryParams.circles === 'true'
        }
        onClick={() => setSalesMethod('Discount', nextStep)}
      >
        Discount
      </Option>
      <Option
        circles={
          queryParams && queryParams.circles && queryParams.circles === 'true'
        }
        onClick={() => setSalesMethod('Cash Offer', nextStep)}
      >
        Cash Offer
      </Option>
      <Option
        circles={
          queryParams && queryParams.circles && queryParams.circles === 'true'
        }
        onClick={() => setSalesMethod('For Sale By Owner', nextStep)}
      >
        For Sale by Owner
      </Option>
      <Option
        circles={
          queryParams && queryParams.circles && queryParams.circles === 'true'
        }
        onClick={() => setSalesMethod('All Options', nextStep)}
      >
        All Options
      </Option>
    </BtnGroup>
  </Card>
);

SalesMethod.propTypes = {
  setSalesMethod: PropTypes.func.isRequired,
  nextStep: PropTypes.number.isRequired,
  queryParams: PropTypes.object,
};

export default SalesMethod;
